import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';

import { LoaderModule, UtilsModule } from '@tablesready/common-ui';
import { FrontendIconsModule } from '@tablesready/frontend-icons';
import { DateFormatPipe } from '@tablesready/frontend-pipes';

import { WaitlistMessagesComponent } from './waitlist-messages.component';
import { ClosePopoverOnScrollDirective } from '../../directives';

@NgModule({
  declarations: [WaitlistMessagesComponent],
  exports: [WaitlistMessagesComponent],
  imports: [
    CommonModule,
    FrontendIconsModule,
    NgbPopoverModule,
    UtilsModule,
    LoaderModule,
    DateFormatPipe,
    ClosePopoverOnScrollDirective,
  ],
})
export class WaitlistMessagesModule {}
